module.exports = {
      id: "banana-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#banana",
      toString: function () {
        return this.url;
      }
    }